import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'COMPANY_STATISTIC_ERROR':
      return action.error;

    case 'COMPANY_STATISTIC_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'COMPANY_STATISTIC_LOADING':
      return action.loading;

    case 'COMPANY_STATISTIC_RESET':
      return false;

    default:
      return state;
  }
}

export function retrieved(state = null, action) {
  switch (action.type) {
    case 'COMPANY_STATISTIC_SUCCESS':
      return action.retrieved;

    case 'COMPANY_STATISTIC_RESET':
      return null;

    default:
      return state;
  }
}

export function filtersData(state = null, action) {
  switch (action.type) {
    case 'COMPANY_STATISTIC_FILTER':
      return action.filtersData;

    case 'COMPANY_STATISTIC_RESET':
      return null;

    default:
      return state;
  }
}

export default combineReducers({ error, loading, retrieved, filtersData });
